import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { InsightsService } from '../../services/insights/insights.service';
import * as Highcharts from 'highcharts/highcharts';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import { AlertBannerService, AlertType } from '../../lib/alert-banner';
import { BrowserModule } from '@angular/platform-browser';
import { SolidgaugeChartService } from '../../services/solidgauge-chart/solidgauge-chart.service';
import HighchartsMore from 'highcharts/highcharts-more';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);

@Component({
  selector: 'app-pulse-nps-breakdown',
  templateUrl: './pulse-nps-breakdown.component.pug',
  styleUrls: ['./pulse-nps-breakdown.component.scss'],
  standalone: false
})
export class PulseNpsBreakdownComponent implements OnInit, OnChanges {
  @Input() start!: any;
  @Input() end!: any;
  @Input() department!: any;
  @Input() request = ''
  @Input() survey = ''
  @Input() pause_load = false;

  promoter = 0;
  passive = 0;
  detractor = 0;
  Highcharts: typeof Highcharts = Highcharts;
  promoterChartOptions = SolidgaugeChartService.getOptions(
    this.promoter,
    '#32735F',
    'rgb(244,248,247)'
  );
  passiveChartOptions = SolidgaugeChartService.getOptions(
    this.passive,
    '#DE8C02',
    'rgb(253,249,242)'
  );
  detractorChartOptions = SolidgaugeChartService.getOptions(
    this.detractor,
    '#AF0001',
    'rgb(250,242,242)'
  );

  constructor(
    private insightsService: InsightsService,
    private alertList: AlertBannerService,
    private permissionsService: PermissionsService
  ) {}

  ngOnInit(): void {}

  private loadAndSetData() {
    if (this.pause_load) {
      return;
    }
    this.insightsService
      .getPulsenpsBreakdown(this.start, this.end, this.department, this.survey, this.request)
      .subscribe(
        (data) => {
          this.promoter = 0
          this.detractor = 0
          this.passive = 0
          for (let d of data) {
            if (d['score'] === 'promoter') {
              this.promoter = d['percentage'];
            } else if (d['score'] === 'passive') {
              this.passive = d['percentage'];
            } else if (d['score'] === 'detractor') {
              this.detractor = d['percentage'];
            }
          }

          this.setChartOptions();
        },
        (error) => {
          console.log(error);
          this.promoter = this.passive = this.detractor = 0;
          this.setChartOptions();
          this.alertList.append([
            {
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true,
            },
          ]);
        }
      );
  }

  private setChartOptions() {
    this.promoterChartOptions = SolidgaugeChartService.getOptions(
      this.promoter,
      '#32735F',
      'rgb(244,248,247)'
    );
    this.passiveChartOptions = SolidgaugeChartService.getOptions(
      this.passive,
      '#DE8C02',
      'rgb(253,249,242)'
    );
    this.detractorChartOptions = SolidgaugeChartService.getOptions(
      this.detractor,
      '#AF0001',
      'rgb(250,242,242)'
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadAndSetData();
  }
}
